import React from 'react'
import Contents from './Contents'
import Taiyeheader from './Taiyeheader'


const LogIn = () => {
  return (
    <div className=' bg-zinc-150 h-[100vh]  bg-no-repeat bg-cover '>
    <Taiyeheader/>
    <Contents/>
    </div>
  )
}

export default LogIn
